import type { Event, EventHint } from "@sentry/core";
import { getEnv } from "@remi/environment";

const AXIOM_ORG_SLUG = "remi-ov0m";

function buildAxiomLogUrl(traceId: string, axiomDataset: string): string {
  const now = new Date();
  const twelveHoursBefore = new Date(now.getTime() - 12 * 60 * 60 * 1000);
  const twelveHoursAfter = new Date(now.getTime() + 12 * 60 * 60 * 1000);
  const initForm = JSON.stringify({
    apl: `['${axiomDataset}'] | where trace_id == '${traceId}'`,
    startTime: twelveHoursBefore.toISOString(),
    endTime: twelveHoursAfter.toISOString(),
  }).replace(/ /g, "%20");
  return `https://app.axiom.co/${AXIOM_ORG_SLUG}/query?initForm=${initForm}`;
}

/**
 * beforeSend hook that adds Axiom context (trace query URL) to Sentry events.
 * Extracts trace_id from the event's trace context and builds a deep link to Axiom.
 */
export function addAxiomContextToSentryEvent<T extends Event>(event: T, _hint: EventHint): T {
  try {
    const traceId = event.contexts?.trace?.trace_id;
    if (traceId) {
      const axiomDataset = getEnv("AXIOM_DATASET");
      event.contexts = {
        ...(event.contexts ?? {}),
        axiom: {
          type: "axiom",
          trace_id: traceId,
          log_url: buildAxiomLogUrl(traceId, axiomDataset),
        },
      };
    }
  } catch {
    // Don't break Sentry error reporting if Axiom context fails
  }

  return event;
}
